import gsap from "gsap";
import React, { useRef } from "react";
import { useState } from "react";
import "./card.css";

export default function Card({
  interactive = true,
  frontContent,
  backContent,
  accentColor = "rgba(255, 41, 162, 0.6)",
  className,
}) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isFlipping, setIsFlipping] = useState(false);
  const cardRef = useRef(null);
  const bgCircleRef = useRef(null);
  const bgRef = useRef(null);

  const flip = async () => {
    if (!interactive) return;
    setIsFlipping(true);
    await gsap.to(cardRef.current, {
      rotateY: 140,
      duration: 0.3,
    });
    setIsFlipped(!isFlipped);
    await gsap.to(cardRef.current, {
      rotateY: 0,
      duration: 0.3,
    });
    setIsFlipping(false);
  };

  function handleMouseEnter(event) {
    if (!interactive) return;
    const element = bgCircleRef.current;
    const elementContainer = bgRef.current;
    const card = cardRef.current;
    const { left, top, width, height } = card.getBoundingClientRect();
    const x = -width * (1 - Math.abs(-(event.clientX - left)) / width);
    const y = -height * (1 - Math.abs(-(event.clientY - top)) / height);
    element.style.backgroundColor = accentColor;
    element.style.transform = `scale(3)`;
    elementContainer.style.transform = `translate(${x}px, ${y}px)`;
  }

  function handleMouseLeave(event) {
    if (!interactive || isFlipping) return;
    const element = bgCircleRef.current;
    const elementContainer = bgRef.current;
    const card = cardRef.current;
    const { left, top, width, height } = card.getBoundingClientRect();
    const x = -width * (1 - Math.abs(-(event.clientX - left)) / width);
    const y = -height * (1 - Math.abs(-(event.clientY - top)) / height);
    element.style.backgroundColor = accentColor;
    element.style.transform = `scale(0)`;
    elementContainer.style.transform = `translate(${x}px, ${y}px)`;
  }

  return (
    <div
      className={`card-container ${
        interactive ? "card-flippable" : ""
      } ${className}`}
      onClick={flip}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      ref={cardRef}
    >
      <div className="card-inner">
        {!isFlipped ? frontContent : backContent}
      </div>
      <div className="card-bg" ref={bgRef}>
        <div id="circle-accent-color" ref={bgCircleRef} />
      </div>
    </div>
  );
}
